import { useEffect, useRef } from "react";
import { UserFieldGroup } from "../components/form/UserFieldsGroup";
import { JsonField } from "../components/form/fields/JsonField";
import { WIDGET_CONFIGS } from "../constants/widgetConfig";
import { useParamsForms } from "../hooks/useParamsForms/useParamsForms";
import { renderSendWidget } from "@cedelabs/widgets-universal";
import { CedeSend } from "@cedelabs/widgets/src";
import { Box, Card, Typography, useTheme } from "@mui/material";

const sendWidgetConfig = WIDGET_CONFIGS.WIDGETS[0];

const universalSendWidgetConfig = WIDGET_CONFIGS.WIDGETS[1];

export const Widgets = () => {
  const theme = useTheme();
  const universalSendWidgetContainerRef = useRef<HTMLDivElement>(null);
  const sendWidgetForm = useParamsForms((state) => state.forms[sendWidgetConfig.methodName]);
  const universalSendWidgetForm = useParamsForms((state) => state.forms[universalSendWidgetConfig.methodName]);
  const mode = useParamsForms((state) => state.mode);
  const timeoutId = useRef<NodeJS.Timeout>();

  const { themeMode, ...sendWidgetConfigValues } = sendWidgetForm;

  useEffect(() => {
    if (universalSendWidgetContainerRef.current) {
      clearTimeout(timeoutId.current);
      const { themeMode, ...config } = universalSendWidgetForm;
      timeoutId.current = setTimeout(
        () =>
          renderSendWidget("#universal-send-widget", { config, theme: { mode: themeMode || "dark", width: "800px" } }),
        300,
      );
    }
  }, [universalSendWidgetForm]);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: theme.custom.smallGutterMargin,
        marginBottom: theme.custom.bigGutterMargin,
      }}
    >
      <Box display={"flex"} gap={theme.custom.gutterMargin} flexDirection={"column"}>
        <Typography
          sx={{
            fontSize: "25px",
            lineHeight: "40px",
            fontWeight: "600",
          }}
        >
          Widget
        </Typography>
        <Card
          data-testid={`actionCard-send-widget`}
          sx={{
            bgcolor: theme.palette.background.component,
            borderRadius: theme.custom.largeBoxRadius,
            padding: theme.custom.gutterMargin,
            display: "flex",
            flexDirection: "column",
            gap: theme.custom.gutterMargin,
            width: "100%",
          }}
        >
          <Typography sx={{ color: theme.palette.text.primary, textAlign: "center" }}>Widget configuration</Typography>
          {mode === "user" && <UserFieldGroup method={sendWidgetConfig} id={"widget-config-fields"} />}
          {mode === "json" && <JsonField method={sendWidgetConfig} />}
        </Card>
        <Box data-testid="send-widget">
          <CedeSend config={sendWidgetConfigValues} theme={{ mode: themeMode || "dark" }} />
        </Box>
      </Box>
      <Box display={"flex"} gap={theme.custom.gutterMargin} flexDirection={"column"}>
        <Typography
          sx={{
            fontSize: "25px",
            lineHeight: "40px",
            fontWeight: "600",
          }}
        >
          Universal Widget
        </Typography>
        <Card
          data-testid={`actionCard-universal-send-widget`}
          sx={{
            bgcolor: theme.palette.background.component,
            borderRadius: theme.custom.largeBoxRadius,
            padding: theme.custom.gutterMargin,
            display: "flex",
            flexDirection: "column",
            gap: theme.custom.gutterMargin,
            width: "100%",
          }}
        >
          <Typography sx={{ color: theme.palette.text.primary, textAlign: "center" }}>
            Universal Widget configuration
          </Typography>
          {mode === "user" && (
            <UserFieldGroup method={universalSendWidgetConfig} id={"universal-widget-config-fields"} />
          )}
          {mode === "json" && <JsonField method={universalSendWidgetConfig} />}
        </Card>
        <Box
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: `repeat(auto-fill, minmax(350px, 1fr))`,
            gap: theme.custom.bigGutterMargin,
          }}
          data-testid="universal-send-widget"
          id="universal-send-widget"
          ref={universalSendWidgetContainerRef}
        ></Box>
      </Box>
    </Box>
  );
};
